import { AppModule } from "@app/app.module";
import { Subscription } from "rxjs";
import { FeatureFlagService } from "../../services/feature-flag.service";

export interface IFeatureFlagSet {
  featureFlagSet: object;
}

export function UseFeatureFlagSet(): ClassDecorator {
  return function(target: Function) {
    const originalNgOnInit = target.prototype.ngOnInit;
    const originalNgOnDestroy = target.prototype.ngOnDestroy;
    let sub: Subscription;
    Object.assign(target.prototype, {
      featureFlagSet: {},
    });

    target.prototype.ngOnInit = function() {
      const service = AppModule.injector.get<FeatureFlagService>(FeatureFlagService);
      if (!service) {
        throw new Error('featureFlagService is missing. Ensure it is injected in the constructor');
      }
      sub = service.featureFlagSets.subscribe((data: any) => {
        this.featureFlagSet = data;
      });
      if (originalNgOnInit) {
        originalNgOnInit.apply(this);
      }
    };

    target.prototype.ngOnDestroy = function() {
      sub?.unsubscribe();
      if (originalNgOnDestroy) {
        originalNgOnDestroy.apply(this);
      }
    };
  };
}

